<template>
  <div class="headerH5">
    <div class="logo" @click="goto">
      <img src="@/assets/logoH5.png" class="logo" alt="" />
    </div>
    <div class="menu-box" @click="setShow">
      <div class="img-menu" :class="show ? 'active' : ''"></div>
    </div>
  </div>
</template>

<script>
import menu from "@/assets/menu.png";
export default {
  data() {
    return {
      menu,
    };
  },
  props: {
    //是否显示弹窗
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    goto() {
      if (this.$route.name == "h5index") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5index",
      });
    },
    setShow() {
      this.$emit("setShow", !this.show);
    },
  },
};
</script>

<style lang="less" scoped>
.headerH5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  width: 750px;
  padding: 0 24px;
  .logo {
    width: 155px;
    height: 56px;
  }
  .menu-box {
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    padding-left: 8px;
    justify-content: right;
    position: relative;
    .img-menu {
      width: 44px;
      height: 6px;
      background: #336fff;
      border-radius: 4px;
      display: block;
      transition: all 0.2s;
      &.active {
        transition: all 0.2s;
        background: none;
      }
      &.active::after {
        content: "";
        width: 44px;
        height: 6px;
        background: #336fff;
        border-radius: 4px;
        position: absolute;
        left: 6px;
        top: 13px;
        transform-origin: bottom right;
        transform: rotate(-45deg);
        transition: all 0.2s;
      }
      &.active::before {
        content: "";
        width: 44px;
        height: 6px;
        background: #336fff;
        border-radius: 4px;
        position: absolute;
        left: 6px;
        bottom: 13px;
        transform-origin: top right;
        transform: rotate(45deg);
        transition: all 0.2s;
      }
    }
    .img-menu::after {
      content: "";
      width: 44px;
      height: 6px;
      background: #336fff;
      border-radius: 4px;
      position: absolute;
      left: 6px;
      top: 13px;
      transform: rotate(0deg);
      transition: all 0.2s;
    }
    .img-menu::before {
      content: "";
      width: 44px;
      height: 6px;
      background: #336fff;
      border-radius: 4px;
      position: absolute;
      left: 6px;
      bottom: 13px;
      display: block;
      transition: all 0.2s;
      transform: rotate(0deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/headerH5.vue